import { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import { LoginForm } from "@/components/auth/LoginForm";
import { useAuthStore } from "@/state/authStore";

export function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const login = useAuthStore((state) => state.login);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const loading = useAuthStore((state) => state.loading);
  const bootstrapSession = useAuthStore((state) => state.bootstrapSession);

  useEffect(() => {
    if (!isAuthenticated) {
      void bootstrapSession();
    }
  }, [bootstrapSession, isAuthenticated]);

  if (isAuthenticated) {
    return <Navigate to="/manager" replace />;
  }

  const destination = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;

  return (
    <div className="flex h-screen items-center justify-center bg-ink-900 px-4 text-ink-50">
      <div className="w-full max-w-sm rounded-xl border border-ink-700 bg-ink-850 p-6 shadow-xl">
        <h1 className="text-lg font-semibold tracking-tight">Entrar no LinkFlow</h1>
        <p className="mt-1 text-xs text-ink-300">Use sua conta para acessar o Manager e o Viewer.</p>
        <div className="mt-6">
          {loading ? (
            <div className="rounded-md border border-ink-700 bg-ink-800 px-3 py-2 text-sm text-ink-300">
              Validando sessão...
            </div>
          ) : (
            <LoginForm
              loading={submitting}
              onSubmit={async (email, password) => {
                setSubmitting(true);
                try {
                  await login(email, password);
                  navigate(destination ?? "/manager", { replace: true });
                } finally {
                  setSubmitting(false);
                }
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
